// Role-based navigation permissions
export const ROLES = {
  super_admin: "Super Admin",
  director: "Director",
  branch_manager: "Branch Manager",
  secretary: "Secretary",
  teacher: "Teacher",
  student: "Student",
  parent: "Parent",
  accountant: "Accountant",
};

export const ROLE_BADGE = {
  super_admin: { label: "Super Admin", color: "bg-brand-red text-white" },
  director: { label: "Director", color: "bg-primary text-primary-foreground" },
  branch_manager: { label: "Manager", color: "bg-blue-600 text-white" },
  secretary: { label: "Secretary", color: "bg-amber-500 text-white" },
  teacher: { label: "Teacher", color: "bg-emerald-600 text-white" },
  student: { label: "Student", color: "bg-violet-600 text-white" },
  parent: { label: "Parent", color: "bg-sky-600 text-white" },
  accountant: { label: "Accountant", color: "bg-orange-600 text-white" },
};

// Which roles see which nav items
export const NAV_ACCESS = {
  dashboard: ["super_admin", "director", "branch_manager", "secretary", "teacher", "accountant"],
  portal: ["student", "parent"],
  teacher_portal: ["teacher", "super_admin", "director"],
  students: ["super_admin", "director", "branch_manager", "secretary", "teacher", "accountant"],
  teachers: ["super_admin", "director", "branch_manager", "secretary"],
  courses: ["super_admin", "director", "branch_manager", "secretary", "teacher"],
  classes: ["super_admin", "director", "branch_manager", "secretary", "teacher"],
  attendance: ["super_admin", "director", "branch_manager", "secretary", "teacher"],
  payments: ["super_admin", "director", "branch_manager", "accountant"],
  announcements: ["super_admin", "director", "branch_manager", "secretary", "teacher", "student", "parent", "accountant"],
  messages: ["super_admin", "director", "branch_manager", "secretary", "teacher", "student", "parent", "accountant"],
  reports: ["super_admin", "director", "branch_manager", "accountant"],
  users: ["super_admin", "director"],
  settings: ["super_admin", "director", "branch_manager", "secretary", "teacher", "student", "parent", "accountant"],
};

export const canAccess = (key, role) => (NAV_ACCESS[key] || []).includes(role);
